import { Component } from "react"
import DefaultFrame from "../../components/DefaultFrame"
import { MediaManagerComponent } from "./MediaManagerComponent"

class MediaManagerPage extends Component {
    render() {
        return (
            <DefaultFrame title="Media Management">
                <MediaManagerComponent />
            </DefaultFrame>
        )
    }
}
export default MediaManagerPage